import React from "react";
import styles from './StudentAllocationCard.module.scss';
import ProfilePicture from "../profilePicture/ProfilePicture";
import PropTypes from "prop-types";
import Checkbox from "../checkbox/Checkbox";
import DropDownButton from "../dropDownButton/DropDownButton";
import Tag from "../tag/Tag";
import {ReactComponent as XIcon} from './X.svg';

const StudentAllocationCard = ({
  profilePicture,
  firstName,
  lastName,
  data,
  onClick,
  showSelect = false,
  isSelected = false,
  toggleSelection,
  showActions = false,
  actions,
  onClose,
  tag
}) => {
  return (
    <div
      className={`${styles.card} ${onClick ? styles.clickable : ''}`}
      onClick={onClick}
    >
      <div className={styles.header}>
        {showSelect && <Checkbox
          checked={isSelected}
          onChange={(value) => toggleSelection(value)}
        />}
        <div className={styles.profile}>
          <ProfilePicture
            profilePicture={profilePicture}
            firstName={firstName}
            lastName={lastName}
          />
          <div className={styles.nameRow}>
            <h4>{firstName} {lastName}</h4>
            {tag && <Tag text={tag.text} variant={tag.variant} rounded={true} />}
          </div>
        </div>
        {showActions && <div className={styles.dots} onClick={(e) => e.stopPropagation()}>
          <DropDownButton
            items={actions}
            type="dots"
          />
        </div>}
        {onClose && <XIcon onClick={onClose} className={styles.close} />}
      </div>
      <table className={styles.table}>
        <tbody>
          {data.map(item => <tr key={item.label}>
            <th>{item.label}</th>
            <td title={item.tooltip ?? ''}>{item.value}</td>
          </tr>)}
        </tbody>
      </table>
    </div>
  );
};

StudentAllocationCard.propTypes = {
  profilePicture: PropTypes.string,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      tooltip: PropTypes.string
    })
  ).isRequired,
  onClick: PropTypes.func,
  showSelect: PropTypes.bool,
  isSelected: PropTypes.bool,
  toggleSelection: PropTypes.func,
  showActions: PropTypes.bool,
  actions: PropTypes.array,
  onClose: PropTypes.func,
  tag: PropTypes.shape({
    text: PropTypes.string.isRequired,
    variant: PropTypes.number.isRequired
  })
};

export default StudentAllocationCard;